import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { NewCasinoGame } from 'interfaces/new-casino';
import {
  getCasinoOriginalCategories,
  getCasinoOriginalCategoriesSet,
  getCasinoOriginalCategoriesSetLeftSideBar
} from 'store/selectors/new-casino';
import { useCasinoGamesConfigsValues } from '../providers/CasinoGamesConfigsContext';

type TUseGamesOrderProps = {
  games:
    | null
    | (null | {
        count: number;
        games: NewCasinoGame[];
        id: string;
        categoryName: string;
      })[];
};

export const useGamesOrder = ({ games }: TUseGamesOrderProps) => {
  const { computedConfigs } = useCasinoGamesConfigsValues();

  const originalCategories = useSelector(getCasinoOriginalCategories);
  const originalCategoriesSet = useSelector(getCasinoOriginalCategoriesSet);
  const leftSideBarOriginalCategoriesSet = useSelector(
    getCasinoOriginalCategoriesSetLeftSideBar
  );

  const categoriesSet = useMemo(() => {
    return (
      (computedConfigs.leftSideBarAvailable
        ? leftSideBarOriginalCategoriesSet
        : originalCategoriesSet) ?? []
    );
  }, [
    computedConfigs.leftSideBarAvailable,
    originalCategoriesSet,
    leftSideBarOriginalCategoriesSet
  ]);

  const originalCategoriesSortArray = useMemo(() => {
    if (categoriesSet.length === 0) {
      return originalCategories?.map(category => category.id) || [];
    } else {
      return categoriesSet;
    }
  }, [originalCategories, categoriesSet]);

  const orderedGames = useMemo(
    () =>
      games?.sort((categoryGamesA, categoryGamesB) => {
        // sorting category games by actual categories order
        const categoryAIndex = originalCategoriesSortArray.indexOf(
          categoryGamesA?.id || ''
        );

        const categoryBIndex = originalCategoriesSortArray.indexOf(
          categoryGamesB?.id || ''
        );

        return categoryAIndex - categoryBIndex;
      }) || null,
    [games, originalCategoriesSortArray]
  );

  return { orderedGames };
};
